<script setup>
</script>

<template>
    <footer class="bg-gray-800">
        <div class="mx-auto max-w-7xl py-6 px-6 md:flex md:items-center md:justify-between justify-center lg:px-8">
            <p class="text-center text-xs leading-5 text-gray-400 ml-6">&copy; 2026 Tavern of Azoth Entertainment Inc. All rights reserved.</p>
            <div class="mt-4 text-center md:order-1 md:mt-0 md:text-left md:flex-grow md:flex md:items-center md:justify-end">
                <nav class="hidden sm:flex space-x-6 justify-center md:justify-start">
                    <router-link to="/privacy-policy" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Privacy Policy</router-link>
                    <span class="text-xs leading-5 text-gray-400">|</span>
                    <router-link to="/terms-and-conditions" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Terms and Conditions</router-link>
                    <span class="text-xs leading-5 text-gray-400">|</span>
                    <router-link to="/faq" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Faq</router-link>
                    <span class="text-xs leading-5 text-gray-400">|</span>
                    <router-link to="/ai-assistants" class="text-xs leading-5 text-gray-400 hover:text-gray-300">AI Assistants</router-link>
                    <span class="text-xs leading-5 text-gray-400">|</span>
                    <router-link to="/how-to-play" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Framework</router-link>
                    <span class="text-xs leading-5 text-gray-400">|</span>
                    <router-link to="/press" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Press</router-link>
                    <span class="text-xs leading-5 text-gray-400">|</span>
                    <router-link to="/support" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Support</router-link>
                </nav>
            </div>
            <nav class="sm:hidden flex flex-col space-y-2 justify-end">
                <router-link to="/privacy-policy" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Privacy Policy</router-link>
                <router-link to="/terms-and-conditions" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Terms and Conditions</router-link>
                <router-link to="/faq" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Faq</router-link>
                <router-link to="/ai-assistants" class="text-xs leading-5 text-gray-400 hover:text-gray-300">AI Assistants</router-link>
                <router-link to="/how-to-play" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Framework</router-link>
                <router-link to="/press" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Press</router-link>
                <router-link to="/support" class="text-xs leading-5 text-gray-400 hover:text-gray-300">Support</router-link>
            </nav>
        </div>
    </footer>
</template>
